/**
 * What the owner step's optional "Property name" starts with: the organisation
 * title, but only when the user named the property. A title that is still the
 * person's own name (first and family name, which is what a new owner
 * organisation is created with) is not a name, so the field starts empty and
 * saving it empty leaves the title alone. Without a known person the field also
 * starts empty.
 */
export function getPropertyNamePrefill({
  title,
  firstname,
  familyname,
}: {
  title: string;
  firstname: string | undefined;
  familyname: string | undefined;
}): string {
  const name = title.trim();
  if (!name || firstname === undefined || familyname === undefined) {
    return "";
  }
  const personName = [firstname, familyname]
    .map(part => part.trim())
    .filter(Boolean)
    .join(" ");
  return name === personName ? "" : name;
}
